import { useMemo } from "react";
import _ from "lodash";
import dayjs from "dayjs";
import { useTranslation } from "react-i18next";
import { Box, Grid2, Stack, Typography, useTheme } from "@mui/material";
import Icon from "../../../../Icon/Icon";
import { EGSpeedDial } from "../../../../MainComponents/Button/SpeedDial/SpeedDial";
import { InvestigationBlockInfo } from "../components/InvestigationBlockInfo";
import { InvestigationItemContainer } from "../components/InvestigationItemContainer";
import { UploadedFile } from "../components/InvestigationComponents";

export const SingleChainOfCustody = ({
  idxCoc,
  coc, 
  selectedChainOfCustody,
  setSelectedChainOfCustody,
  setShowChainOfCustody,
  idxEvidence,
  evidences,
  handleSaveEvidenceDetails,
  kindMoveCustodyOpts, 
  justView,
}) => {

  const [t] = useTranslation("investigation");
  const theme = useTheme();

  const receivedAt = useMemo(() => {
    const fecha = dayjs(coc.date_collection).format("DD/MMM/YYYY");
    if (fecha == "Invalid Date") return t("Evidences.undefined");
    const hora = coc.time_collection ? `- ${coc.time_collection}` : "";
    return `${fecha.toLocaleUpperCase()} ${hora.toLocaleLowerCase()}`;
  }, [coc.date_collection, coc.time_collection]);

  const handleEditChainOfCustody = () => {
    setSelectedChainOfCustody(idxCoc);
    setShowChainOfCustody(true);
  }

  const handleRemoveChainOfCustody = () => {
    const newEvidences = _.cloneDeep(evidences);
    newEvidences[idxEvidence].cocs = newEvidences[idxEvidence].cocs.filter((_, idx) => idx !== idxCoc);
    handleSaveEvidenceDetails(newEvidences);
  }

  const actions = [
    {
      name: t("speeddial.edit"),
      icon: <Icon name="outline_edit" color={theme.palette.primary.main} />,
      onClick: handleEditChainOfCustody,
    },
    {
      name: t("speeddial.delete"),
      icon: <Icon name="trash_can" color={theme.palette.error.main} />,
      onClick: () => handleRemoveChainOfCustody(idxCoc),
    },
  ];

  return (
    <InvestigationItemContainer
      color="#546F7A"
      sx={{ p: 2 }}
    >
      <Stack direction="row" justifyContent="space-between">

        <Stack direction="row" alignItems="center">
          {/* <Icon 
            name="bold_origin_search"
            size={16}
            color="#B694FF"
            style={{ marginRight: "5px" }}
          /> */}
          <Typography fontSize={14} fontWeight={400} >
            {t("Evidences.movement")}:
          </Typography>
          &nbsp;
          <Typography fontSize={14} fontWeight={700} color="#546F7A" >
            {kindMoveCustodyOpts.find(opt => opt.value === coc.kind)?.label}
          </Typography>
        </Stack>

        {
          !justView &&
          <Box style={{ minWidth: "35px", position: "relative" }}>
            <EGSpeedDial
              direction="left"
              actions={actions}
              sx={{
                position: "absolute",
                top: "50%",
                right: 0,
                transform: "translateY(calc(-50% - 5px))",
                scale: 0.8,
              }}
            />
          </Box>
        }

        </Stack>

        <hr className="hr-div"/>

        <Grid2 container spacing={2}>

          <Grid2 size={12} display="flex" alignItems="flex-start" gap={1}>
            <Icon name="timer2_bold" color={theme.palette.yellow.main} />
            <Typography fontSize={14} fontWeight={600} color={theme.palette.secondary.main}>{t("Evidences.reception_date")}: &nbsp;
              <Typography component="span" fontWeight={700} fontSize={16} color={theme.palette.yellow.main}>{receivedAt}</Typography>
            </Typography>
          </Grid2>

          {
            coc.package &&
            <Grid2 size={12} >
              <InvestigationBlockInfo 
                label={t("Evidences.description_of_packaging")}
                text={coc.package}
                size={12}
              />
            </Grid2>
          }

          {
            coc.status &&
            <Grid2 size={{ xs: 12, md: 6 }} >
              <InvestigationBlockInfo 
                label={t("Evidences.status")}
                text={coc.status}
                size={12}
              />
            </Grid2>
          }
          {
            coc.place &&
            <Grid2 size={{ xs: 12, md: 6 }} >
              <InvestigationBlockInfo 
                label={t("Evidences.place")}
                text={coc.place}
                size={12}
              />
            </Grid2>
          }

          {
            coc.facilitator &&
            <Grid2 size={{ xs: 12, md: 6 }} >
              <InvestigationBlockInfo 
                label={t("Evidences.facilitator")}
                text={coc.facilitator}
                size={12}
              />
            </Grid2>
          }

          {
            coc.collector &&
            <Grid2 size={{ xs: 12, md: 6 }} >
              <InvestigationBlockInfo 
                label={t("Evidences.collector")}
                text={coc.collector}
                size={12}
              />
            </Grid2>
          }

          {
            coc.files.length > 0 &&
            coc.files.map((file, idx) => (
              <Grid2 size={{ xs: 12, md: 6 }} key={idx}>
                <UploadedFile
                  text={file.name}
                  preview={true}
                  url={file.url}
                  sx={{
                    maxWidth: "400px",
                  }}
                />
              </Grid2>
            ))
          }

        </Grid2>

    </InvestigationItemContainer>
  )
}